import {APIStatusType} from '@web/core/constants'

/** 정산상세 카테고리 */
export const SaleSettlementStatusCategory = {
    /** 정산완료 */
    SETTLE_COMPLETE: 'SETTLE_COMPLETE',
    /** 정산예정 */
    SETTLE_SCHEDULE: 'SETTLE_SCHEDULE',
    /** 정산취소 */
    CANCEL_COMPLETE: 'CANCEL_COMPLETE',
    /** 취소중 */
    CANCEL_SCHEDULE: 'CANCEL_SCHEDULE',
} as const
export type SaleSettlementStatusCategoryType = Constant<typeof SaleSettlementStatusCategory>

const StatusCategoryCodeToNameMap: Record<SaleSettlementStatusCategoryType | 'ALL', string> = {
    ALL: '전체',
    SETTLE_COMPLETE: '정산완료',
    SETTLE_SCHEDULE: '정산예정',
    CANCEL_SCHEDULE: '취소중',
    CANCEL_COMPLETE: '정산취소',
}

export const getSaleSettlementStatusCategoryToName = (code: string) => {
    return StatusCategoryCodeToNameMap[code as SaleSettlementStatusCategoryType | 'ALL'] ?? ''
}

/** 정산방법 */
export const SettlementMethod = {
    /** 환불정산액 */
    REFUND_AMOUNT: 'REFUND_AMOUNT',
    /** 계좌이체 */
    BANK_TRANSFER: 'BANK_TRANSFER',
} as const
export type SettlementMethodType = Constant<typeof SettlementMethod>

/** 정산항목 카테고리 */
export const SaleSettlementDetailCategory = {
    /** 상품주문 */
    PROD_ORDER: 'PROD_ORDER',
    /** 배송비 */
    DELIVERY: 'DELIVERY',
    /** 기타비용 */
    EXTRA_FEE: 'EXTRA_FEE',
    /** 기타공제환급 */
    DEDUCTION_RESTORE: 'DEDUCTION_RESTORE',
} as const
export type SaleSettlementDetailCategoryType = Constant<typeof SaleSettlementDetailCategory>
const DetailCategoryCodeToNameMap: Record<SaleSettlementDetailCategoryType | 'ALL', string> = {
    ALL: '전체',
    PROD_ORDER: '상품주문',
    DELIVERY: '배송비',
    EXTRA_FEE: '기타비용',
    DEDUCTION_RESTORE: '공제환급',
}

export const getSaleSettlementDetailCategoryToName = (code: string) => {
    return DetailCategoryCodeToNameMap[code as SaleSettlementDetailCategoryType | 'ALL'] ?? ''
}

export type SaleSettlementState = {
    /** 결제 일시 (ISO 형식) */
    paymentDate: string
    /** 정산방식 */
    method?: SettlementMethodType
    /** 정산 요약 */
    summary: {
        complete: {
            /** 정산완료 금액 총액 */
            amount: number
            /** 정산완료 상품주문 건수 */
            count: number
        }
        expect: {
            /** 정산예정 상품주문 금액 */
            amount: number
            /** 정산예정 상품주문 건수 */
            count: number
        }
        detail: {
            /** 정산완료 금액 총액 */
            totalAmount: number
            /** 정산완료 기준 금액 */
            baseAmount: number
            /** 정산완료 상품주문 금액 */
            productOrderAmount: number
            /** 정산완료 기타비용 금액 */
            extraFeeAmount: number
            /** 정산완료 공제환급 금액 */
            deductionRestoreAmount: number
            /** 정산완료 배송비 금액 */
            deliveryFeeAmount: number
            /** 정산완료 기타 금액 */
            etcAmount: number
            /** 정산완료 마이너스 상계 금액 */
            minusSetOffAmount: number
            /** 정산완료 지급보류 금액 */
            payHoldBackAmount: number
        }
    }
    /** 지급보류 상세내역 */
    payHold: {
        status: APIStatusType
        selected: {
            startDate: string
            endDate: string
        }
        items: {
            id: string
            /** 일자 */
            date: string
            /** 구분 */
            type: string
            /** 사유 */
            reason: string
            /** 금액 */
            amount: number
        }[]
        /** 금액 합계 */
        totalAmount: number
    }
}

export type RootState = {saleSettlement: SaleSettlementState}
